import isBlank from 'is-blank'
import {
  SET_ID,
  SET_NAME,
  SET_WORKSPACE,
  SET_LOGO,
  CLIENT_DEFAULT_LOGO
} from './types'

export const state = {
  id: null,
  name: '',
  workspace: '',
  logo: CLIENT_DEFAULT_LOGO,
}

export const mutations = {
  [SET_ID] (state, value) {
    state.id = value
  },
  [SET_NAME] (state, value) {
    state.name = value
  },
  [SET_WORKSPACE] (state, value) {
    state.workspace = value
  },
  [SET_LOGO] (state, value) {
    state.logo = isBlank(value) ? CLIENT_DEFAULT_LOGO : value
  }
}

export const actions = {
  setId ({ commit }, value) {
    commit(SET_ID, value)
  },
  setName ({ commit }, value) {
    commit(SET_NAME, value)
  },
  setWorkspace ({ commit }, value) {
    commit(SET_WORKSPACE, value)
  },
  setSvgLogo ({ commit }, value) {
    commit(SET_SVG_LOGO, logo)
  },
  applyClient ({ commit, dispatch }, client) {
    commit(SET_ID, client.id)
    commit(SET_NAME, client.name)
    commit(SET_WORKSPACE, client.workspace)
    commit(SET_LOGO, client.logo)

    dispatch('clientTheme/setTheme', client.theme)
    dispatch('clientTheme/apply')
  }
}

export const getters = {
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/clients/client.js